<template>
	<div id="sa-sales-master-report">
		<p-card :class="{ collapsed: !expanded }">
			<template #header>
				<div class="flex align-items-center justify-content-between h-full" @click="expanded = !expanded">
					<h2>Sales Associates</h2>
					<div class="expander">
						<icon type="chevron-down" size="24px" />
					</div>
				</div>
			</template>
			<template #content>
				<p-data-table
					ref="sa_master_report"
					:value="reportData"
					:loading="loading"
					data-key="account_manager_id"
					row-group-mode="subheader"
					group-rows-by="account_manager_id"
					class="master-report-table"
					scrollable
				>
					<template #empty>
						<div class="dim">No Data</div>
					</template>
					<template #loading>
						<line-loader :show="loading" />
					</template>
					<template #groupheader="row">
						<div class="sticky-heading">
							{{ row.data.account_manager_name }}
						</div>
					</template>
					<p-column header="Sales Associate" frozen>
						<template #body="row">
							<div class="data-cell">Spend</div>
							<div class="data-cell">Active Buyers</div>
							<template v-if="row.data.account_manager_id === 'TOTAL'">
								<div class="data-cell">Support Spend</div>
								<div class="data-cell">Support Active Buyers</div>
							</template>
						</template>
					</p-column>
					<p-column :header="aggregateType" frozen>
						<template #body="row">
							<div class="data-cell">
								{{ currency(row.data[aggregate].spend) }}
							</div>
							<div class="data-cell">{{ row.data[aggregate].active_accounts }}</div>
							<template v-if="row.data.account_manager_id === 'TOTAL'">
								<div class="data-cell">{{ currency(row.data[aggregate].cs_spend) }}</div>
								<div class="data-cell">{{ row.data[aggregate].cs_active_accounts }}</div>
							</template>
						</template>
					</p-column>
					<p-column v-for="date in dateRange" :header="date">
						<template #body="row">
							<div
								:class="[
									'data-cell',
									colorCell(row.data.data[date].spend, row.data.ranges.spend[0], row.data.ranges.spend[1]),
								]"
							>
								{{ currency(row.data.data[date].spend) }}
							</div>
							<div
								:class="[
									'data-cell',
									colorCell(
										row.data.data[date].active_accounts,
										row.data.ranges.active_accounts[0],
										row.data.ranges.active_accounts[1]
									),
								]"
							>
								{{ row.data.data[date].active_accounts }}
							</div>
							<template v-if="row.data.account_manager_id === 'TOTAL'">
								<div
									:class="[
										'data-cell',
										colorCell(
											row.data.cs_data[date]?.spend || 0,
											row.data.ranges.cs_spend[0],
											row.data.ranges.cs_spend[1]
										),
									]"
								>
									{{ currency(row.data.cs_data[date]?.spend || 0) }}
								</div>
								<div
									:class="[
										'data-cell',
										colorCell(
											row.data.cs_data[date]?.active_accounts || 0,
											row.data.ranges.cs_active_accounts[0],
											row.data.ranges.cs_active_accounts[1]
										),
									]"
								>
									{{ row.data.cs_data[date]?.active_accounts || 0 }}
								</div>
							</template>
						</template>
					</p-column>
					<p-column class="width-hack"></p-column>
				</p-data-table>
			</template>
		</p-card>
	</div>
</template>

<script>
import { colorCell, currency } from '@/lib/Filters';

export default {
	name: 'SASalesMasterReport',
	props: {
		aggregate: {
			type: String,
			default: 'totals',
		},
		rawReportData: {
			type: Array,
			default() {
				return [];
			},
		},
		loading: Boolean,
	},
	data() {
		return {
			expanded: true,
		};
	},
	computed: {
		aggregateType() {
			if (this.aggregate === 'totals') {
				return 'Total';
			}
			return 'Average';
		},
		reportData() {
			return this.rawReportData;
		},
		dateRange() {
			if (this.reportData.length > 0) {
				return Object.keys(this.reportData[0].data);
			}
			return [];
		},
	},
	methods: {
		colorCell,
		currency,
	},
};
</script>

<style scoped lang="less">
:deep(.p-card-body) {
	padding: 0;
}
</style>
